import React, { useState, useEffect, useContext } from "react";
import PluginWorksStyles from "../../../../assets/css/components/admin/products/PluginWork.css";
import { Form } from "react-bootstrap";
import { keyProductsListDropdownPlugin, keyUserActiveEnterpriseId } from "../../../../assets/js/SessionStorageNames";
import { GlobalContext } from "../../../../contexts/GlobalContext";

export default function SelectBrand(props) {
  const globalContext = useContext(GlobalContext);
  const axios = require("axios");
  const [statusDropDown, setStatusDropDown] = useState([]);
  const accessTokenKey = localStorage.getItem("accessTokenKey");
  const idUser = localStorage.getItem("_id");
  
  /**
   * ? metodo para guardar el valor del select
   */
  const selectPlugin = (e) => {
    props.setCurrentPlugin(e.target.value);
  };

  /**
   * Set the selected brand
   */
  const selectBrand = (e) => {
    props.updateBrand(e.target.value);
  }

  /**
   * Get the available plugins
   */
  useEffect(() => {
    // Intentar obtener el ID de la empresa del contexto o del localStorage
    const entId = globalContext.currentEnterpriseId || localStorage.getItem(keyUserActiveEnterpriseId);
    
    if (!entId) {
      console.log("SelectBrand.jsx: No se encontró ID de empresa en contexto ni en localStorage");
      return;
    }
    
    axios({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/v1/main-plugin/available/${entId}`,
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": accessTokenKey,
        "x-user-id": idUser,
      },
    })
      .then((res) => {
        // Filtrar elementos null/undefined antes de guardar
        const validPlugins = res.data.data ? res.data.data.filter(plugin => plugin != null) : [];
        setStatusDropDown(validPlugins);

        //If there isn't a selected plugin
        if (!localStorage.getItem(keyProductsListDropdownPlugin)) {
          axios
            .get(`${process.env.REACT_APP_BACKEND_URL}/v1/main-plugin`, {
              headers: {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": accessTokenKey,
                "x-user-id": idUser,
              },
            })
            .then((res) => props.setCurrentPlugin(res.data.data))
            .catch((err) => console.log(err));
        }
      })
      .catch((err) => {
        globalContext.showModalWithMsg(
          "Disculpe ha ocurrido un error al intentar cargar la lista de plugins"
        );
        if (err.response) {
          console.log(err.response.data);
        } else {
          console.log(err);
        }
      });
    //eslint-disable-next-line
  }, [globalContext.currentEnterpriseId]);

  //Select the currently active plugin ID on the first load
  useEffect(() => {
    const currentEntId = localStorage.getItem(keyProductsListDropdownPlugin);

    if (currentEntId) {
      props.setCurrentPlugin(currentEntId);
    }
    //eslint-disable-next-line
  }, []);

  //Change the plugin value in storageSession
  useEffect(() => {
    localStorage.setItem(keyProductsListDropdownPlugin, props.currentPlugin);
  }, [props.currentPlugin]);

  return (
    <PluginWorksStyles>
      {
        props.currentPlugin === "ml" && props.brands && props.brands.length > 0 && (
          <Form.Control
            as="select"
            onChange={selectBrand}
            value={props.currentBrand}
          >
            <option key="" value="">
              Seleccione una tienda
            </option>
            {props.brands.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </Form.Control>
        )
      }
      {
        props.currentPlugin === "cashea" && props.brands && props.brands.length > 0 && (
          <>
            <Form.Control
            as="select"
            onChange={selectBrand}
            value={props.currentBrand}
          >
            <option key="" value="">
              Seleccione una tienda
            </option>
            {props.brands.map((b) => (
              <option key={b.id} value={b.name}>
                {b.name}
              </option>
            ))}
          </Form.Control>
          </>
        )
      }
    </PluginWorksStyles>
  );
}
